import React from "react";
import * as ReactDOMClient from "react-dom/client";
import { App } from "./App";
import { initializeIntl } from "./i18n";

const container = document.getElementById("app");
if (container == null) throw new Error("no_app");
const root = ReactDOMClient.createRoot(container);

initializeIntl(["signalement"], document.location.pathname.startsWith("/en/") ? "en-CA" : "fr-CA", {
    saveMissing: false,
    debug: false
}).then(() => {
    root.render(
        <React.Suspense fallback={<div></div>}>
            <App />
        </React.Suspense>,
    );
});
